/**
 * Sends performance timing of Vector events to GTM.
 * @param {string} eventName - The name of the Vector event.
 * @param {number} timeToLoad - The performance.now() timestamp.
 */

function sendVectorEventToGTM(eventName) {
	const timeToLoad = Math.round(performance.now());
	if (typeof gtag === "function" && timeToLoad) {
		gtag("event", "vector_performance", {
			event_category: "PerformanceObserver",
			event_label: eventName,
			value: Math.round(timeToLoad),
		});
	}
}

window.addEventListener("message", (event) => {
	if (event.origin !== "https://vector.techopg.com") {
		return;
	}

	const key = event.data && event.data.key; // Use key instead of action

	switch (key) {
		case "vector.script.loaded":
		case "vector.campaign.fetching":
		case "vector.campaign.fetched":
		case "vector.app.rendered":
			sendVectorEventToGTM(key);
			break;
		default:
			break;
	}
});
